const privacyPolicyES = {
	title: "Política de Privacidad",
	lastUpdated: "Fecha de Vigencia",

	intro: {
		p1: `{{COMPANY_NAME}} (“nosotros”, “nuestro” o “nos”) proporciona una plataforma en línea para ayudar a los clientes a reservar citas en barberías y salones de belleza y para ayudar a barberos y propietarios de negocios a gestionar horarios y comunicaciones (“Servicios”). Esta Política de Privacidad explica qué información recopilamos, cómo la usamos y sus derechos y opciones.`,
		p2: "Al usar nuestro sitio web, aplicación o Servicios, usted acepta esta Política de Privacidad. Si no está de acuerdo, por favor no use los Servicios.",
	},

	infoCollect: {
		heading: "1. Información que Recopilamos",

		provided: "a) Información que Usted Proporciona",
		providedList: [
			"Datos de cuenta: nombre, correo electrónico, número de teléfono, contraseña (cifrada), información de perfil, idioma preferido.",
			"Datos de reservas y negocios: servicios seleccionados, fecha/hora, barbero o negocio, notas, estado e historial de reservas.",
			"Comunicaciones: mensajes enviados a nosotros, recordatorios o notificaciones que enviamos (por ejemplo, confirmaciones de reserva).",
		],

		automatic: "b) Información Recopilada Automáticamente",
		automaticList: [
			"Datos de dispositivo y uso: dirección IP, tipo de navegador, páginas visitadas, marcas de tiempo y analítica básica.",
			"Cookies y tecnologías similares para recordar preferencias, mantener sesión iniciada y mejorar los Servicios.",
		],

		thirdParty: "c) Información de Terceros",
		thirdPartyList: [
			"Cuentas de redes sociales o integraciones de terceros que conecte.",
			"Procesadores de pagos (solo para tarifas de negocios).",
		],
	},

	howWeUse: {
		heading: "2. Cómo Usamos su Información",
		list: [
			"Proporcionar, operar y mejorar los Servicios, incluyendo reservas, horarios, notificaciones y soporte al cliente.",
			"Procesar pagos y gestionar cuentas de negocios (nota: no procesamos pagos entre clientes y proveedores de servicios).",
			"Enviar mensajes transaccionales como confirmaciones, recordatorios o actualizaciones.",
			"Personalizar su experiencia y recordar preferencias.",
			"Monitorear el rendimiento, prevenir fraudes o abusos y mantener la seguridad.",
			"Cumplir con obligaciones legales.",
		],
	},

	sharing: {
		heading: "3. Cómo Compartimos la Información",
		list: [
			"Con Barberos/Negocios que Reserva: detalles necesarios para que puedan prestar el servicio.",
			"Con Proveedores de Servicios: proveedores de confianza (hosting, correo electrónico, analítica, procesadores de pagos para tarifas de negocios).",
			"Legal, Seguridad y Cumplimiento: si la ley lo requiere o para proteger derechos, seguridad o integridad de usuarios o de los Servicios.",
			"Transferencias de Negocios: en conexión con fusiones, adquisiciones o ventas de activos.",
		],
		noSell: "No vendemos datos personales a terceros.",
	},

	cookies: {
		heading: "4. Cookies y Analítica",
		text: "Las cookies esenciales son necesarias para operar los Servicios; las cookies de analítica opcionales nos ayudan a entender el uso. Puede gestionar cookies desde su navegador, pero algunas funciones pueden no funcionar correctamente si se desactivan.",
	},

	security: {
		heading: "5. Seguridad de los Datos",
		text: "Implementamos medidas técnicas y organizativas razonables (cifrado, controles de acceso) para proteger su información. Ningún método de almacenamiento o transmisión es 100% seguro.",
	},

	retention: {
		heading: "6. Retención de Datos",
		text: "Conservamos su información personal solo mientras sea necesario para prestar los Servicios, cumplir obligaciones legales, resolver disputas y hacer cumplir acuerdos. Si elimina su cuenta, podemos retener información limitada según lo requiera la ley o por intereses comerciales legítimos.",
	},

	international: {
		heading: "7. Transferencias Internacionales",
		text: "Su información puede ser procesada o almacenada en países distintos al suyo. Cuando sea necesario, usamos salvaguardas apropiadas para transferencias transfronterizas.",
	},

	minors: {
		heading: "8. Consentimiento Parental / Menores de Edad",
		p1: "Usuarios menores de la mayoría de edad en su jurisdicción solo pueden usar los Servicios con el consentimiento de un padre o tutor legal.",
		p2: "Nuestros Servicios no están dirigidos a niños menores de 13 años (o la edad mínima en su jurisdicción). No recopilamos a sabiendas información personal de niños sin consentimiento parental.",
	},

	userContent: {
		heading: "9. Contenido Generado por Usuarios",
		p1: "Reseñas, mensajes y otro contenido que envíe puede ser mostrado en la plataforma.",
		p2: "Al enviar contenido, nos otorga una licencia mundial, libre de regalías y no exclusiva para alojar, mostrar y distribuir el contenido para operar los Servicios.",
	},

	platform: {
		heading: "10. Recordatorio de Responsabilidad de la Plataforma",
		p1: "Sin Fila es solo una plataforma. No somos responsables de la calidad, disponibilidad o legalidad de los servicios proporcionados por terceros.",
		p2: "Todas las reservas, cancelaciones y disputas son principalmente entre el usuario y el negocio.",
	},

	rights: {
		heading: "11. Sus Derechos y Opciones",
		list: [
			"Acceso y Actualización: editar información de cuenta en su perfil.",
			"Eliminar: solicitar eliminación de su cuenta e información personal, sujeto a obligaciones legales.",
			"Marketing: optar por no recibir correos electrónicos no esenciales.",
			"Cookies: gestionar desde el navegador.",
		],
		contact: "Para ejercer sus derechos o realizar solicitudes, contacte a {{CONTACT_EMAIL}}.",
	},

	changes: {
		heading: "12. Cambios a Esta Política de Privacidad",
		text: "Podemos actualizar esta Política de Privacidad periódicamente. Cambios importantes serán comunicados por correo electrónico, aplicación o aviso en el sitio web.",
	},

	contact: {
		heading: "13. Contacto",
		text: "Para preguntas sobre esta Política o sobre cómo manejamos sus datos, contacte a {{CONTACT_EMAIL}}.",
	},
};

export default privacyPolicyES;
